<template>
  <section class="marketplace-cart">
    <header class="flex items-end">
      <h2 class="text-2xl m-0">{{ 'My Cart' | t }}</h2>
      <p class="text-lg ml-sm">(0 {{ 'items in cart' | t }})</p>
    </header>
    <div class="flex flex-col items-start mt-lg mb-lg sm:flex-row">
      <p class="text-lg fw-strong">{{ 'Your cart is empty.' | t }}</p>
      <p class="text-lg mt-sm sm:mt-0 sm:ml-sm">{{ 'Shop for these Sloan parts and products.' | t }}</p>
    </div>
    <EmptyCartTeaser />
  </section>
</template>

<script>
import t from '../../main/i18n';
import SloButton from '../../../lib/components/SloButton.vue';
import SloProductImage from '../../../lib/components/SloProductImage.vue';
import EmptyCartTeaser from '../components/EmptyCartTeaser.vue';

export default {
  components: {
    EmptyCartTeaser,
    SloButton,
    SloProductImage
  },
  filters: {
    t
  }
};
</script>

<style lang="scss">
.marketplace-cart {
  margin-block-end: 5.6rem;

  header {
    p {
      line-height: 2;
    }
  }
}
</style>
